import { Component, signal } from '@angular/core';
import { Filter } from '../../../store/search/types';
import { SmartAction } from '../../../store/view/types';
import { SearchService } from '../../../store/search/search.service';
import { Router } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-smart-action-link',
  standalone: false,
  templateUrl: './smart-action-link.component.html',
  styleUrl: './smart-action-link.component.scss',
})
export class SmartActionLinkComponent implements ICellRendererAngularComp {
  readonly textValue = signal<string>('');
  readonly activateLink = signal<boolean>(false);

  idProperty: string;
  data: any;

  smartAction: SmartAction;

  constructor(
    private readonly searchService: SearchService,
    private readonly router: Router,
  ) {}

  agInit(params: ICellRendererParams): void {
    this.refresh(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.textValue.set(params.value);

    this.data = params.data;

    const route = params['route'];

    this.idProperty = params['idProperty'];
    const filter = this.data[this.idProperty] as Filter;

    this.activateLink.set(!!filter);

    const name = params['name'];
    const actionName = params['actionName'];

    this.smartAction = {
      id: name,
      label: actionName,
      url: route,
      count: 0,
      filter: filter,
      icon: '',
      actif: true,
      singleId: '',
    };
    return true;
  }

  onSmartLinkClick(): void {
    this.searchService.temporaryKeepActiveFilters(
      this.router.url,
      this.smartAction.url,
    );

    this.searchService.addActiveFilter(this.smartAction.filter, true);
    this.searchService.resetActiveFilter();

    this.router.navigate([this.smartAction.url], {
      state: { useTempFilter: true },
    });
  }
}
